Button = require 'components/common/button'
LabelCell = require 'components/etd/etd_header_label_cell'
EtdHeaderEditableCell = require 'components/etd/etd_header_editable_cell'
Translation = require 'components/mixins/translation'
CustomRenderMixin = require 'components/mixins/custom_render_mixin'

EtdHeaderRow = createReactClass
  displayName: 'EtdHeaderRow'
  mixins: [Translation('es:recommendations.header'), CustomRenderMixin]

  focusEditCell: ->
    if @props.isEditing
      @refs[@props.sectionId]?.focus()

  saveContent: ->
    @refs[@props.sectionId]?.saveContent?()

  _getEditCellProps: (sectionProps) ->
    return {
      renderMode: @props.renderMode
      ref: sectionProps.sectionId
      content: sectionProps.cellContent
      contentComponent: sectionProps.cellContentComponent
      sectionId: sectionProps.sectionId
      isEditing: sectionProps.isEditing
      inAutoMode: sectionProps.inAutoMode
      questionType: sectionProps.questionType
      updateHeaderFieldContent: sectionProps.updateHeaderFieldContent
      hasSwitchButton: sectionProps.hasSwitchButton
      showContentModeSwitchModal: sectionProps.showContentModeSwitchModal
    }

  _shouldRenderContentAsRows: ->
    @props.sectionId in ['mainOutcomes', 'outcomes'] and @props.cellContentComponent?

  _renderSwitchButton: ->
    return null unless @props.isEditing and @props.hasSwitchButton

    switchButtonLabel = if @props.inAutoMode then 'switch_to_manual' else 'switch_to_auto'
    <Button
      className="btn auto-manual-switch "
      label={$.t "es:question.#{switchButtonLabel}"}
      onClick={@props.showContentModeSwitchModal}
    />

  render: ->
    editCellProps = @_getEditCellProps @props
    component = if @_shouldRenderContentAsRows()
      <td className="cell-nested-component">
        {React.cloneElement @props.cellContentComponent,
          cellLabel: @props.cellLabel
          inAutoMode: @props.inAutoMode
          isEditing: @props.isEditing
          showContentModeSwitchModal: @props.showContentModeSwitchModal
        }
        {@_renderSwitchButton()}
      </td>
    else
      <EtdHeaderEditableCell {...editCellProps} />

    trClassess = classNames 'switch-button': editCellProps.hasSwitchButton
    <tr className={trClassess}>
      <LabelCell text={@props.cellLabel} renderMode={@props.renderMode} />
      {component}
    </tr>

module.exports = EtdHeaderRow
